module.exports = __webpack_public_path__ + "static/media/another-end.cf803c2f.webp";